import React, {Component, Fragment} from "react";
import {withTranslation} from "react-i18next";
import {Button,Table, TableHead, TableBody, TableRow, TableCell, TableContainer} from "@material-ui/core";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ClearIcon from "@material-ui/icons/Clear";

import buildUrl from "build-url";

class SubscriptionStatus extends Component {
    render = () => {

        var {email, subscriptionActive, trialActive, trialEnd, level, hmac, t} = this.props;

        return <Fragment>
                <dl>
                    <dt>{t("Email")}</dt>
                    <dd><b>{email}</b></dd>
                    {(!subscriptionActive) && trialEnd &&
                        <Fragment>
                            <dt>{t("Free trial until")}</dt>
                            <dd><b>{trialEnd.replace("T", " ").substring(0, 19)}</b></dd>
                            </Fragment>
                        }

                    {level &&
                        <Fragment>
                            <dt>{t("Level")}</dt>
                            <dd><b>{level}</b></dd>
                        </Fragment>}

                    <dt>{t("HMAC")}</dt>
                    <dd><b>{hmac}</b></dd>
                </dl>

            </Fragment>;
        }
    }

SubscriptionStatus = withTranslation()(SubscriptionStatus);

class SubscriptionActions extends Component {

    onSubscribe = (productId, planId) => {
        var {host, signalGuid, session} = this.props;
        var redirectUrl = buildUrl(host, {path: "done", queryParams: {state: signalGuid}});
        var subscribeUrl = buildUrl(host, {path: "subscribe", queryParams: {product: productId, plan: planId, continue: redirectUrl, error: redirectUrl, session: session}});
        window.localStorage.setItem("packerSubscriptionUpdate", "{}");
        window.open(subscribeUrl);
        }

    onPortal = () => {
        var {host, signalGuid, session} = this.props;
        var redirectUrl = buildUrl(host, {path: "done", queryParams: {state: signalGuid}});
        var portalUrl = buildUrl(host, {path: "portal/"+ session, queryParams: {done: redirectUrl, error: redirectUrl}});
        window.localStorage.setItem("packerSubscriptionUpdate", "{}");

        window.open(portalUrl);
        }

    render = () => {

        var {subscriptionActive, host, t} = this.props;

        return <Fragment>
            <Subscriptions onSubscribe={this.onSubscribe} host={host} subscriptionActive={subscriptionActive}/>
            </Fragment>;
        }
    }

SubscriptionActions = withTranslation()(SubscriptionActions);

class Subscriptions extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            plans: []
            };

        var plansUrl = buildUrl(this.props.host, {path: "plans"});

        fetch(plansUrl)
            .then((response) => response.json())
            .then((result) => {
                this.setState(result);
                });
        }

    onSubscribe = (productId, planId) => {
        this.props.onSubscribe(productId, planId);
        }

    render = () => {
        var {subscriptionActive} = this.props;

        var plans = this.state.plans.map((x) =>  <MatrixLine data={x} onSubscribe={this.onSubscribe} subscriptionActive={subscriptionActive} />);

        return <Fragment>
                <TableContainer>
                    <Table>
                        <TableBody>{plans}</TableBody>
                    </Table>
                </TableContainer>
            </Fragment>;
        }
    }
class MatrixLine extends Component {
    render =() => {
        var {data, onSubscribe, subscriptionActive} = this.props;

        var cells = data.map((x)=> <MatrixElement data={x} onSubscribe={onSubscribe} subscriptionActive={subscriptionActive}/>);

        return <TableRow>
                {cells}
            </TableRow>
        }
    }

class MatrixElement extends Component {
    onSubscribe = () => {
        var productId = this.props.data[1];
        var planId = this.props.data[2];
        this.props.onSubscribe(productId, planId);
        }
    render = () => {
        var {data, subscriptionActive} = this.props;

        var content = data;

        if (typeof(data) != "string") {
            if (!subscriptionActive) {
                content = <Button variant="contained" onClick={this.onSubscribe} color="secondary">{data[0]}</Button>
                } else {
                content = data[0];
                }
            }
        switch (content) {
            case "+":
                content = <CheckCircleIcon />;
                break;

            case "-":
                content = <ClearIcon />;
                break;

            default:
                break;

            }
        return <TableCell>{content}</TableCell>;
        }
    }

export {SubscriptionStatus, SubscriptionActions}